import { z } from 'zod';
import { VendorStatus } from '../../constants/vendor-status.js';
import { optionalEditFormTrimmedEmail, optionalEnumIdString, optionalNonNegativeIntString, optionalNonNegativeNumberString, optionalUuidString, } from '../zod-helpers/index.js';
import { VENDOR_CONSTRAINTS } from './constraints.js';
import { checkVendorCommercialRequired, checkVendorIdentity, checkVendorStatusRequired, } from './rules.js';
export const vendorFormFieldsSchema = z.object({
    name: z.string().max(VENDOR_CONSTRAINTS.name.maxLength),
    url: z.string().max(VENDOR_CONSTRAINTS.url.maxLength),
    note: z.string().max(VENDOR_CONSTRAINTS.note.maxLength),
    email: optionalEditFormTrimmedEmail(VENDOR_CONSTRAINTS.email.maxLength, `Invalid ${VENDOR_CONSTRAINTS.email.label.toLowerCase()}.`),
    phone: z.string().max(VENDOR_CONSTRAINTS.phone.maxLength),
    currencyId: optionalUuidString('Invalid currency selection.'),
    paymentTermsId: optionalUuidString('Invalid payment terms selection.'),
    shipTermsId: optionalUuidString('Invalid ship terms selection.'),
    carrierId: optionalUuidString('Invalid carrier selection.'),
    creditLimit: optionalNonNegativeNumberString(VENDOR_CONSTRAINTS.creditLimit.label),
    leadTime: optionalNonNegativeIntString(VENDOR_CONSTRAINTS.leadTime.label),
    minOrderAmount: optionalNonNegativeNumberString(VENDOR_CONSTRAINTS.minOrderAmount.label),
});
export const vendorEditFormFieldsSchema = vendorFormFieldsSchema.extend({
    statusId: optionalEnumIdString(VendorStatus, 'Invalid vendor status.'),
});
/**
 * Full-record edit submit, not a partial GraphQL patch. `updateVendorInputSchema`
 * marks paymentTermsId / shipTermsId / carrierId / statusId `.optional()` meaning
 * "omit to leave unchanged" — the columns are NOT NULL. These required-checks close
 * the hole where `''` maps to `undefined` and silently keeps the old DB value.
 */
export const vendorEditFormSchema = vendorEditFormFieldsSchema.superRefine((values, context) => {
    for (const issue of checkVendorIdentity(values)) {
        context.addIssue({ code: 'custom', message: issue.message, path: [issue.path] });
    }
    for (const issue of checkVendorCommercialRequired(values)) {
        context.addIssue({ code: 'custom', message: issue.message, path: [issue.path] });
    }
    for (const issue of checkVendorStatusRequired(values)) {
        context.addIssue({ code: 'custom', message: issue.message, path: [issue.path] });
    }
});
export const emptyVendorFormValues = () => ({
    name: '',
    url: '',
    note: '',
    email: '',
    phone: '',
    currencyId: '',
    paymentTermsId: '',
    shipTermsId: '',
    carrierId: '',
    creditLimit: '',
    leadTime: '',
    minOrderAmount: '',
});
export const emptyVendorEditFormValues = () => ({
    ...emptyVendorFormValues(),
    statusId: '',
});
//# sourceMappingURL=update-form.js.map